import React, { FC } from 'react'
import { CLabel } from '@coreui/react'
import { ICON_TYPE } from '../../api/types/enums.types'
import PIcon from '../icons/PIcon/PIcon'
import CIcon from '@coreui/icons-react'

const CIconText = (props: any) => {
  const { iconName, iconClassName, iconType, outerTagClass, labelStr, labelClass } = props
  let IconComponent = iconType && iconType === ICON_TYPE.P ? PIcon : CIcon
  return (
    <span className={outerTagClass}>
      <IconComponent name={iconName} className={iconClassName} />
      <CLabel className={labelClass || 'header-title mr-0 pr-0'}>{labelStr}</CLabel>
    </span>
  )
}
export default CIconText
